export default __webpack_public_path__ + "static/media/mejormesa.974ef473.png";